<div class="plotly-area plot-box">
    <ng-container *ngIf="this.rawDatasetLoaded != true">
        <div class="loading" id="wrapper">
            <mat-icon class="loading" id="icon">query_stats</mat-icon>
            <mat-progress-spinner mode="indeterminate" color="primary" class="loading" id="spinner"></mat-progress-spinner>
        </div>
    </ng-container>

    <div class="select-data-box" id="wrapper" *ngIf="this.graphDataLoaded != true && this.rawDatasetLoaded == true">
        <div class="select-data-box" id="background-image-div">
            <img
                class="select-data-box"
                id="background-image"
                src="../../../../assets/images/general/graphBackground.png"
                alt="Background for graph view - a schematic blurred graph"
                height="600"
                width="1044"
            />
        </div>
        <div class="select-data-box" id="notice-wrapper">
            <mat-card class="select-data-box" id="notice">
                <mat-card-content>{{ 'MASCHINESTATE.GRAPH.SUBSTITUTE' | translate}}</mat-card-content>
            </mat-card>
        </div>
    </div>

    <ng-container *ngIf="this.graphDataLoaded == true">
        <plotly-plot
            id=""
            class="plotly-area"
            [data]="this.plotSettings.data"
            [layout]="this.plotSettings.layout"
            [config]="this.plotSettings.config"
            [useResizeHandler]="true"
            [style]="this.plotSettings.style"
        ></plotly-plot>
    </ng-container>
</div>
